import React from 'react';
import withTracker from '../hoc/withTracker';
import defaultTrackingOptions from '../utils/defaultTrackingOptions';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

class TrackOnMount extends React.Component {
  constructor(props) {
    super(props);

    this.getTrackingOptions = this.getTrackingOptions.bind(this);
  }

  getTrackingOptions() {
    return {
      ...defaultTrackingOptions(),
      tipologia_versione: themeResponsiveProperty('mobile', 'tablet')(this.props),
      ...this.props.options,
    };
  }

  render() {
    return null;
  }
}

export default withTheme(withRouter(withTracker(TrackOnMount)));
